<template>
  <node-view-wrapper
    contenteditable="false"
    class="editable-shorttag-block"
  >
    <div
      class="content"
      draggable="true"
      data-drag-handle
    >
      <content-link-list
        :key="nodePropsKey"
        :list-title="nodeProps.listTitle"
        :list-title-class="nodeProps.listTitleClass"
        :list-title-heading-type="nodeProps.listTitleHeadingType"
        :list-more="nodeProps.listMore"
        :list-elements="nodeProps.listElements"
        :style-class="nodeProps.styleClass"
        :sort="nodeProps.sort"
      />
      <content-link-list-btn
        btn-type="update"
        :link-list-title-prop="nodeProps.listTitle"
        :link-list-title-class-prop="nodeProps.listTitleClass"
        :link-list-title-heading-type-prop="nodeProps.listTitleHeadingType"
        :link-list-data-prop="nodeProps.listElements"
        @update-content="tiptapContentUpdate"
      />
    </div>
  </node-view-wrapper>
</template>

<script>
import {
  NodeViewWrapper,
  nodeViewProps,
} from '@tiptap/vue-2';
import { sha256 } from 'js-sha256';
import ContentLinkListBtn from './ContentLinkListBtn.vue';
import ContentLinkList from '../ContentLinkList.vue';

export default {
  components: {
    NodeViewWrapper,
    ContentLinkListBtn,
    ContentLinkList,
  },
  props: {
    ...nodeViewProps,
    ...ContentLinkList.props,
  },
  computed: {
    nodeProps() {
      return this.node?.attrs;
    },
    // needed for re-rendering if user changes some img src
    nodePropsKey() {
      return sha256(JSON.stringify(this.node?.attrs));
    }
  },
  methods: {
    tiptapContentUpdate(updateData) {
      this.updateAttributes(updateData.attrs);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  cursor: grab;
}
</style>
